import React, { useState } from 'react';
import FilterItems from './FilterItems/FilterItems';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as categoryActions from '../../../../actionCreators/category';
import { readQueryParam } from '../../../../utils/helper';
import { filterHelper } from './FilterPanel.helper';

const FilterDtm = {
  updateFilterDtm: (filterName, filterType) => {
    let parentKeyToUpdateDtm = filterName;
    if (parentKeyToUpdateDtm?.indexOf('_id') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace(/_/g, '').replace('id', '');
    } else if (parentKeyToUpdateDtm?.indexOf('lenskart') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace('lenskart_', '');
    } else if (parentKeyToUpdateDtm?.indexOf('price') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.concat('range');
    }
    if (filterType) window.dtm.filterType = 'clear all';

    window.dtm[parentKeyToUpdateDtm] = 'clear';
  },
  updateCategoryDtm: (categoryData, dtmArg) => {
    let subC = '';
    const { userInfo, login, sort, filter } = dtmArg;
    const bCrumbArr =
      categoryData.breadcrumb && categoryData.breadcrumb.length ? categoryData.breadcrumb : [];
    const categoryType = categoryData.categoryType ? categoryData.categoryType.toLowerCase() : '';
    bCrumbArr.forEach(data => {
      if (data) {
        subC += `${data.label}-`;
      }
    });
    if (window.dtm !== undefined) {
      if (window.dtm.LenskartRewamp) {
        window.dtm.LenskartRewamp.allPage('listing page');
        window.dtm.LenskartRewamp.Listing.load.listing(
          categoryType,
          subC ? subC.slice(0, -1) : categoryType,
          filter,
          sort.toLowerCase(),
          login,
          login ? userInfo.result.id : '',
          dtmArg.obj
        );
      }
    }
  },
};

const FilterPanel = props => {
  const {
    categoryActions,
    addingGaDataInFilterArray,
    FilterDataObj,
    location,
    categoryId,
    showFilterMobile,
    setShowFilterMobile,
    selectedOptions,
    setSelectedOptions,
    mobilePendingSelections,
    setMobilePendingSelections,
    isCategoryTab,
    isMobileSize,
  } = props;

  const [selectedFilter, setSelectedFilter] = useState([]);

  const handleClose = () => {
    setSelectedFilter([]);
    setSelectedOptions({});

    Object.keys(FilterDataObj).forEach(key => {
      FilterDataObj[key] = [];
    });

    if (!isMobileSize) {
      const currentHash = window.location.hash.replace(/^#/, '');
      const params = new URLSearchParams(currentHash);

      Array.from(params.keys()).forEach(key => {
        if (key.startsWith('filter_') || key.includes('_id') || key.includes('price')) {
          params.delete(key);
        }
      });

      const sort = params.get('sort');
      const dir = params.get('dir');
      const ganData = params.get('gan_data');

      const newParams = new URLSearchParams();
      if (sort) newParams.set('sort', sort);
      if (dir) newParams.set('dir', dir);
      if (ganData) newParams.set('gan_data', ganData);

      const newHash = newParams.toString().replace(/%2C/g, ',');

      const newUrl = newHash ? `${location.pathname}#${newHash}` : location.pathname;

      history.replaceState(null, '', newUrl);
      categoryActions.loadCatAndFilterData(categoryId, newHash, 0);
    } else {
      history.replaceState(null, '', location.pathname);
      categoryActions.loadCatAndFilterData(categoryId, '', 0);
    }

    Object.keys(FilterDataObj).forEach(key => {
      FilterDtm.updateFilterDtm(key, true);
    });
  };

  const loadCatData = data => {
    let mystring = '';
    const incLimit = Object.keys(data).length - 1;
    Object.keys(data).forEach((key, parentIndex) => {
      let mystring2 = '';
      mystring += key;
      data[key].forEach((val, index) => {
        if (index === data[key].length - 1) {
          mystring2 += val.childid;
        } else {
          mystring2 = `${mystring2 + val.childid},`;
        }
      });
      if (parentIndex === incLimit) {
        mystring = `${mystring}=${mystring2}`;
      } else {
        mystring = `${mystring}=${mystring2}&`;
      }
    });
    let loc = '';
    if (location.hash.includes('dir')) {
      if (location.hash.split('dir')[0].length > 0 && location.hash.split('dir')[0].length !== 1) {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir') - 1,
          location.hash.lastIndexOf('true') + 4
        );
      } else {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir'),
          location.hash.lastIndexOf('true') + 4
        );
      }
    }

    let searchQuery = '';
    if (location.pathname === '/search' && readQueryParam('q', `${location.search}`, true)) {
      const queryParam = readQueryParam('q', location.search, true);
      searchQuery = `?q=${queryParam}`;
    }

    history.replaceState(
      `${location.pathname}${window.location.hash}`,
      null,
      location.pathname + `${searchQuery}${window.location.hash}`
    );

    categoryActions.loadCatAndFilterData(categoryId, mystring + loc, 0);
  };

  const handleFilter = (name, array, TempData, apiTempData = {}) => {
    filterHelper(name, FilterDataObj, TempData, apiTempData, array, categoryActions, loadCatData);
  };

  const modifySelectedFilterList = (childname, childid, currentFilterData) => {
    const childData = FilterDataObj[currentFilterData.id] || [];
    const index = childData.findIndex(
      item => JSON.stringify(item) === JSON.stringify({ childid, childname })
    );

    if (index > -1) {
      childData.splice(index, 1);
    } else {
      childData.push({ childid, childname });
    }

    const itemIndex = selectedFilter?.indexOf(childname);

    if (itemIndex > -1) {
      setSelectedFilter([...selectedFilter].splice(itemIndex, 1));
    } else {
      setSelectedFilter([...selectedFilter, childname]);
    }

    setSelectedOptions(prev => {
      const prevSelected = prev[currentFilterData.id] || [];
      const updated = prevSelected.includes(childid)
        ? prevSelected.filter(id => id !== childid)
        : [...prevSelected, childid];

      return {
        ...prev,
        [currentFilterData.id]: updated,
      };
    });

    const filter = {
      [currentFilterData?.id]: childname,
    };
    const allFilter = [filter];

    const isContainFilterData = false;

    if (allFilter.length > 0 && !isContainFilterData) {
      const totalFilter = allFilter.length;
      const appliedFilterString = Object.assign({}, ...allFilter);

      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Listing.filter.appliedFilter(appliedFilterString, totalFilter);
    }

    addingGaDataInFilterArray(isContainFilterData, filter, currentFilterData, childname);
    if (childData.length === 0) FilterDtm.updateFilterDtm(currentFilterData.id);

    handleFilter(currentFilterData.id, childData);
  };

  return (
    <React.Fragment>
      <FilterItems
        handleClose={handleClose}
        modifySelectedFilterList={modifySelectedFilterList}
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
        FilterDataObj={FilterDataObj}
        showFilterMobile={showFilterMobile}
        setShowFilterMobile={setShowFilterMobile}
        categoryActions={categoryActions}
        categoryID={categoryId}
        onFilterAppliedCountChange={props.setAppliedTypeCount}
        mobilePendingSelections={mobilePendingSelections}
        setMobilePendingSelections={setMobilePendingSelections}
        isCategoryTab={isCategoryTab}
      />
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
    FilterDataObj: state.category.FilterDataObj,
    filterData: state.category.filterData,
    location: state.router.location,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    categoryActions: bindActionCreators(categoryActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterPanel);
